/**
 * Compatibilidad mínima del storefront sin agregar dependencias ni polyfills globales.
 * Mantener estas utilidades chicas: se ejecutan en el camino crítico de arranque.
 */
export function fromEntries(entries) {
  if (typeof Object.fromEntries === "function") {
    return Object.fromEntries(entries);
  }

  const result = {};
  for (const entry of entries || []) {
    if (!entry || entry.length < 2) continue;
    result[entry[0]] = entry[1];
  }
  return result;
}

export function createAbortController() {
  return typeof AbortController === "function" ? new AbortController() : null;
}

export function abortSignal(controller) {
  return controller?.signal;
}

export function requestWasAborted(controller) {
  return controller?.signal?.aborted === true;
}

export function abortRequest(controller) {
  try {
    controller?.abort?.();
  } catch {
    // Un navegador sin AbortController simplemente deja terminar la request.
  }
}
